import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { storedInteractions } from '../../utils/stored-interactions/stored-interactions';
import { useGetReleaseIdFromParams } from '../use-get-release-id-from-params/use-get-release-id-from-params';

export const useCheckPromoAccess = (catNr: string | undefined) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const releaseId = useGetReleaseIdFromParams();

  const accessUrl = `/promo/${releaseId}/access`;
  const releaseUrl = `/promo/${releaseId}`;

  useEffect(() => {
    if (!catNr) {
      return;
    }

    const isOnAccessPage = pathname === accessUrl;

    if (!isOnAccessPage && !storedInteractions.getHasPromoAccess(catNr)) {
      navigate(accessUrl);
    } else if (isOnAccessPage && storedInteractions.getHasPromoAccess(catNr)) {
      navigate(releaseUrl);
    }
  }, [releaseId, navigate, catNr]);
};
